
import Breadcrumbs from "~/components/global/Breadcrumbs";
export default {
    spacingDebug: false,
    components: {
        Breadcrumbs,
        HeaderTemplate: () => import("~/components/global/templates/HeaderTemplate"),
    },
    props: {
        news_items: {
            type: Array,
            default: () => [],
        },
        news_info: {
            type: Object,
            default: () => ({}),
        },
    },
    data: () => ({
        items: [],
        hero_content: null,
    }),
    computed: {
        populateTags() {
            const categories = Array.isArray(this.news_info.categories) ? this.news_info.categories : [];
            const products = Array.isArray(this.news_info.products) ? this.news_info.products : [];
            return [...categories, ...products].map((item) => item?.name).filter(Boolean);
        },
    },
};
